import { render, staticRenderFns } from "./FormValidator.vue?vue&type=template&id=053e8520&scoped=true"
import script from "./FormValidator.vue?vue&type=script&lang=js"
export * from "./FormValidator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053e8520",
  null
  
)

export default component.exports